import { PrivateUserDto, UserDto } from '@hermes/domains'
import { MessageResponse } from '../auth/api'
import { authenticatedApiInstance } from '../client'

export const uploadProfileImage = async ({ imageFile }: { imageFile: File }): Promise<MessageResponse> => {
  const formData = new FormData()
  formData.append('file', imageFile)

  return authenticatedApiInstance()
    .post(`/user/upload-profile-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => res.data)
}

export const updateMarketingConsent = async (consent: boolean): Promise<MessageResponse> =>
  authenticatedApiInstance()
    .put(`/user/marketing-consent?r=${consent}`)
    .then((res) => res.data)

export const getMe = async ({ token }: { token: string }): Promise<PrivateUserDto> =>
  authenticatedApiInstance(token)
    .get(`/user/me`)
    .then((res) => res.data)

export const getUser = async (userUuid: string): Promise<UserDto> =>
  authenticatedApiInstance()
    .get(`/user/${userUuid}`)
    .then((res) => res.data)
